import { useEffect } from 'react';

import { getIsCopyActivityIntroductionSkipped } from '../../../../../../../db/polls';
import { usePollContext } from '../../../../../Context';
import { getIsActivityPublished } from '../../../../../../../utils/activities';

export interface UseIntroduction {
  goToNextStep: () => void;
}

const useIntroduction = ({ goToNextStep }: UseIntroduction) => {
  const { poll } = usePollContext();

  const isPollPublished = getIsActivityPublished({ publishedOn: poll?.publishedOn });

  useEffect(() => {
    const skipIntroduction: boolean = getIsCopyActivityIntroductionSkipped();

    if (!skipIntroduction) return;

    goToNextStep();
  }, []);

  return { isPollPublished };
};

export default useIntroduction;
